import React, { Component } from 'react';
import moment from 'moment';
export default class CustomerJobsAwaitingInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      invoicingInfo: props.invoicingInfo || props.data.jobs || null,
      runningTotalSelectedInvoicableValue: 0,
      runningTotalSelectedInvoicableJobs: 0,
      jobsSelected: [],
      customerJobCSVJson: null,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      changeInvoiceNumberApiUrl: "/api/v1/portal/jobs/change-invoice-number/",
      selectedJobsZipping: false,
      stopTurnToYellow:false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }
  getSageCSVExportForJobs(jobsToIncludeInInvoice) {
    let jobsToIncludeInInvoiceFiltered = jobsToIncludeInInvoice.filter(function (el) {
      return el != null;
    });
    return fetch(
      '/api/v1/portal/invoice-info/customer/'+
      this.state.data.id+'/batch-csv',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
        body: JSON.stringify({
          jobsToIncludeInInvoice: jobsToIncludeInInvoiceFiltered
        }),
      }
    ).then(
      (responseText) => {
        let response = responseText.json();
        response.then((customerJobCSVJson) => {
          if (customerJobCSVJson.csv) {
            this.downloadCSV(customerJobCSVJson.csv);
          }
        });
      }
    );
  }
  getZipDownloadForSelectedJobs(jobsToIncludeInZip) {
    let jobsToIncludeInZipFiltered = jobsToIncludeInZip.filter(function (el) {
      return el != null;
    });

    this.setState({
      selectedJobsZipping: true
    });

    return fetch(
      '/api/v1/portal/invoice-info/customer/'+
      this.state.data.id+'/combined-zip-download',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
        body: JSON.stringify({
          jobsToIncludeInZip: jobsToIncludeInZipFiltered
        }),
      }
    ).then(
      (responseText) => {
        let response = responseText.json();
        response.then((customerJobZip) => {
          console.log(customerJobZip);
          if (customerJobZip.zip) {
            this.downloadZIP(customerJobZip.zip);
          }
        });
      }
    );
  }
  downloadZIP(zipFile) {
    this.setState({
      selectedJobsZipping: false
    });
    window.location = zipFile;
  }
  downloadCSV(csvTextContent) {
    let that = this;
    let temporaryElement = document.createElement('a');
    temporaryElement.setAttribute(
      'href',
      'data:text/csv;charset:utf-8;,' +
      encodeURIComponent(csvTextContent)
    );
    temporaryElement.setAttribute(
      'download',
      'Gemini - Service Invoice Export - '+
      that.state.data.name+' - '+
      ((moment().format(
          that.state.momentFormatStringCSV)).toString()
      )+'.csv');
    temporaryElement.style.display = 'none';
    document.body.appendChild(temporaryElement);
    temporaryElement.click();
    document.body.removeChild(temporaryElement);
  }

  handleInvoiceExportButtonClick(e, customerId) {
    let jobsToIncludeInInvoice = [];
    this.state.jobsSelected.forEach(function(i) {
      if (i.selected === true) {
        jobsToIncludeInInvoice.push(i.jobId);
      }
    });
    this.getSageCSVExportForJobs(jobsToIncludeInInvoice);
  }

  handleCheckboxClick(e, i) {
    let checkbox = $('i#checkbox-for-job-'+i.id);
    checkbox.toggleClass('fa-check-square').toggleClass('fa-square');
    let isChecked = checkbox.hasClass('fa-check-square'),
      total = parseFloat(i.job_price) +
        parseFloat(i.expenses_price),
      jobsSelected = this.state.jobsSelected;

    if (isChecked) {
      jobsSelected[i.id] = {selected: true, jobId: i.id};
      this.setState({
        runningTotalSelectedInvoicableValue:
          this.state.runningTotalSelectedInvoicableValue + (
            total
          ),
        runningTotalSelectedInvoicableJobs:(
          this.state.runningTotalSelectedInvoicableJobs + 1),
        jobsSelected: jobsSelected,
      });
    }
    else {
      jobsSelected[i.id] = {selected: false, jobId: i.id};
      this.setState({
        runningTotalSelectedInvoicableValue:
          this.state.runningTotalSelectedInvoicableValue - (
            total
          ),
        runningTotalSelectedInvoicableJobs:(
          this.state.runningTotalSelectedInvoicableJobs - 1),
        jobsSelected: jobsSelected,
      });
    }
  }
  handleDownloadAppraisalsAndExpensesForSelectedJobsButtonClick(e, i) {
    this.getZipDownloadForSelectedJobs(this.state.jobsSelected);
  }
  changeInvoiceNumber(jobId) {
    return fetch(
      this.state.changeInvoiceNumberApiUrl+jobId,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
        body: JSON.stringify(
          {
            invoice_number: document.getElementById(
              "job-" + jobId + "-invoice-number"
            ).value
          }
        )
      }
    ).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        alert(jobId+" job invoiced");
      });
    });
  }
  sendMultipleMailToPeople(e,type,jobid){
    let jobsSelected = this.state.jobsSelected;
    jobsSelected[jobid] = {selected: false, jobId: jobid};
    this.setState({  
      jobsSelected:jobsSelected,
      stopTurnToYellow:true
    },()=>{
    return fetch('/api/v1/portal/jobs/'+jobid+'/send-multiple-mail-to-people/'+type,
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }
        ).then((response) => {
          if (response.ok) {
          response.json().then(data => {
            alert(data.msg);
           });
          } else {
            console.log(response);
            let res = response.json();
            res.then((resJson) => {
              alert('There is issue with some data of jobs please check . . .');
            });
          }
        }).catch((error) => { 
          alert('Unable to sent mail..'+error);
        });
    });
  }
  sendMultipleExpenseMailToPeople(e,jobid){
    let jobsSelected = this.state.jobsSelected;
    jobsSelected[jobid] = {selected: false, jobId: jobid};
    this.setState({  
      jobsSelected:jobsSelected,
      stopTurnToYellow:true
    },()=>{
    return fetch('/api/v1/portal/jobs/'+jobid+'/send-multiple-expense-mail-to-people',
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }
        ).then((response) => {
          if (response.ok) {
          response.json().then(data => {
            alert(data.msg);
           });
          } else {
            let res = response.json();
            res.then((resJson) => {
              //alert(resJson);
              alert('There is issue with some data of jobs please check . . .');
            });
          }
        }).catch((error) => { 
          alert('Unable to sent mail..'+error);
        });
    });
  }
  sendMultipleAppraisalPdfMailToPeople(e,type,jobid){
    let jobsSelected = this.state.jobsSelected;
    jobsSelected[jobid] = {selected: false, jobId: jobid};
    this.setState({  
      jobsSelected:jobsSelected,
      stopTurnToYellow:true
    },()=>{
    return fetch('/api/v1/portal/jobs/'+jobid+'/send-multiple-appraisal-mail-to-people/'+type,
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }
        ).then((response) => {
          if (response.ok) {
          response.json().then(data => {
            alert(data.msg);
           });
          } else {
            let res = response.json();
            res.then((resJson) => {
              //alert(resJson);
              alert('There is issue with some data of jobs please check . . .');
            });
          }
        }).catch((error) => { 
          alert('Unable to sent mail..'+error);
        });
    });
  }
  sendExpenseMailToCustomer(e,jobid){
    let jobsSelected = this.state.jobsSelected;
    jobsSelected[jobid] = {selected: false, jobId: jobid};
    this.setState({  
      jobsSelected:jobsSelected,
      stopTurnToYellow:true
    },()=>{
    return fetch('/api/v1/portal/jobs/'+jobid+'/send-expense-mail-to-customer',
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },
          }
        ).then((response) => {
          if (response.ok) {
          response.json().then(data => {
            alert(data.msg);
           });
          } else {
            let res = response.json();
            res.then((resJson) => {
              //alert(resJson);
              alert('There is issue with some data of jobs please check . . .');
            });
          }
        }).catch((error) => { 
          alert('Unable to sent mail..'+error);
        });
    });
  }
  sendAppraisalPdfMailToCustomer(e,type,jobid){
    let jobsSelected = this.state.jobsSelected;
    jobsSelected[jobid] = {selected: false, jobId: jobid};
    this.setState({  
      jobsSelected:jobsSelected,
      stopTurnToYellow:true
    },()=>{
      //console.log(jobid,this.state.jobsSelected[jobid].selected); 
      //console.log('stopTurnToYellow--',this.state.stopTurnToYellow);
    return fetch('/api/v1/portal/jobs/'+jobid+'/send-appraisal-pdf-mail-to-customer/'+type,
          {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              , "Accept": 'application/json'
            },

          }
        ).then((response) => {
          
          // this.response({stopTurnToYellow:false});
          if (response.ok) {
          response.json().then(data => {
            // console.log('data',data.msg);
            alert(data.msg);
           });
            // alert('Mail sent to customer...');
          } else {
            let res = response.json();
            res.then((resJson) => {
              //alert(resJson);
              alert('There is issue with some data of jobs please check . . .');
            });
            // alert('Unable to sent mail..');
          }
        }).catch((error) => { 
          alert('Unable to sent mail..'+error);
        });
    });
  }
  handleXeroInvoiceExportButtonClick(e, customerId) {
    let jobsToIncludeInInvoice = [];
    this.state.jobsSelected.forEach(function(i) {
      if (i.selected === true) {
        jobsToIncludeInInvoice.push(i.jobId);
      }
    });
    let jobsToIncludeInInvoiceFiltered = jobsToIncludeInInvoice.filter(function (el) {
      return el != null;
    });
    return fetch('/api/v1/portal/invoice-info/customer/'+this.state.data.id+'/batch-csv-for-xero',
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
        body: JSON.stringify({
          jobsToIncludeInInvoice: jobsToIncludeInInvoiceFiltered
        }),
      }
    ).then(
      (responseText) => {
        let response = responseText.json();
        response.then((customerJobCSVJson) => {
          if (customerJobCSVJson.csv) {
            this.downloadCSV(customerJobCSVJson.csv);
          }
        });
      }
    );
  }
  render() {
    let CustomerInvoicingItems = [];
    let that = this; //[todo] refactor
    if (this.state.invoicingInfo && this.state.invoicingInfo.length > 0) {
      this.state.invoicingInfo.forEach(function(i) {
        CustomerInvoicingItems.push(
          <div className={"row invoiceable-job invoiceable-job"+(
            (that.state.jobsSelected[i.id] &&
              that.state.jobsSelected[i.id].selected === true && that.state.stopTurnToYellow === false) ?
              ' highlight-yellow ' : '')}
               id={"invoiceable-job-"+i.id}
               key={"invoiceable-job-"+i.id}
               onClick={(e) => {
                 e.preventDefault();
                 e.stopPropagation();
                 e.nativeEvent.stopImmediatePropagation();
                 that.handleCheckboxClick(e, i);
               }}
          >
            <div className="col-md-1">
              <a href={"/jobs/view/"+i.id}>Job #{i.id}</a>
            </div>

            <div className="col-md-2 customer-invoicing-info">
              {
                (i.customer_order_number !== null &&
                  i.customer_order_number.length > 0) ?
                  '(PO: '+i.customer_order_number+') '
                  :
                  ''
              }
              {
                (i.customer_job_number !== null &&
                  i.customer_job_number.length > 0) ?
                  '(JobNumber: '+i.customer_job_number+') '
                  :
                  ''
              }
              {
                i.vehicle.registration_number + " " +
                i.pickup_address.town_city + " " +
                i.pickup_address.postcode + " TO " +
                i.dropoff_address.town_city + " " +
                i.dropoff_address.postcode
              }
            </div>
            <div className="col-md-1">
              &pound;{parseFloat(i.job_price).toFixed(2)}
            </div>
            <div className="col-md-1">
              &pound;{parseFloat(i.expenses_price).
            toFixed(2)}
            </div>

            <div className="col-md-1">
              &pound;{
              (parseFloat(i.expenses_price) + parseFloat(i.job_price)).
              toFixed(2)
            }
            </div>

            <div className="col-md-1">
              {(i.driver_completed_at !== null) ?
                moment(i.driver_completed_at).format(that.state.momentFormatString)
                :
                i.status
              }
            </div>

            <div className="col-md-1">
              {i.to_be_invoiced=='1'?'YES':'NO'
              }
            </div>

            <div className="col-md-4 customer-jobstable-date">
            <a className="text-left" title="Send Mail To People"
              onClick={(e) => {that.sendMultipleMailToPeople(e, 'both', i.id)}}>
                All Docs <i className="fa fa-envelope fa-lg"></i></a>
                &nbsp;
                &nbsp;
            <a className="text-left" title="Send Expense receipts Mail To People"
              onClick={(e) => {that.sendMultipleExpenseMailToPeople(e,i.id)}}>
                EXPENSES <i className="fa fa-envelope fa-lg"></i></a>
                &nbsp;
                &nbsp;
            <a className="text-left" title="Send Appraisal Mail To People"
              onClick={(e) => {that.sendMultipleAppraisalPdfMailToPeople(e,'pod',i.id)}}>
                POD <i className="fa fa-envelope fa-lg"></i></a>
                &nbsp;
                &nbsp;
                <a className="text-left" title="Send Appraisal Mail To People"
              onClick={(e) => {that.sendMultipleAppraisalPdfMailToPeople(e,'poc',i.id)}}>
                POC <i className="fa fa-envelope fa-lg"></i></a>
                &nbsp;
                &nbsp;
              <input
                type="text"
                className="form-control text-center"
                defaultValue={i.invoice_number}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                id={"job-"+i.id+"-invoice-number"}
              />
              <button
                className="btn btn-lg btn-primary"
                onClick={(e) => that.changeInvoiceNumber(i.id)}
              >
                <i className="fa fa-save"></i> Save
              </button>
              <i className="fas fa-square checkbox-for-job"
                 id={"checkbox-for-job-"+i.id}
              ></i>
            </div>
          </div>
        );
      });
    }

    return (
      <div className="customer-jobs-awaiting-invoice-container">
        <div className="row invoiceable-job-header">
          <div className="col-md-1">
            Job ID
          </div>
          <div className="col-md-2">
            Info
          </div>
          <div className="col-md-1">
            Job Price
          </div>
          <div className="col-md-1">
            Expenses Price
          </div>
          <div className="col-md-1">
            Total Invoiced
          </div>
          <div className="col-md-1 customer-jobstable-date">
            Driver Completed At
          </div>
          <div className="col-md-1">
            Invoice
          </div>
          <div className="col-md-4">
            Invoice#
            &nbsp;
          </div>
        </div>
        {CustomerInvoicingItems}

        <div className="customer-invoicing-sage-csv-button-container">
          <p className={"customer-invoicing-running-total-value"+(
            (this.state.data.value_of_jobs_per_invoice_in_pence <
              this.state.runningTotalSelectedInvoicableValue && !this.state.stopTurnToYellow) ?
              ' customer-invoicing-warning ' : ''
          )}
          >
            Total = <strong>&pound;{ !this.state.stopTurnToYellow ?
            (this.state.runningTotalSelectedInvoicableValue).toFixed(2)
            : (0).toFixed(2)
          }
          </strong> / &pound;{
            (this.state.data.value_of_jobs_per_invoice_in_pence / 100).
            toFixed(2)
          }
          </p>
          <p
            className="customer-invoicing-running-total-number-of-jobs"
          >
            Number of Jobs = <strong>{ !this.state.stopTurnToYellow ?
            this.state.runningTotalSelectedInvoicableJobs : 0
          }
          </strong> / {parseInt(this.state.data.number_of_jobs_per_invoice) || 0}
          </p>

          <button
            className="btn btn-lg btn-outline-success customer-invoicing-combined-assets-download"
            onClick={(e) => {
             e.preventDefault();
             this.handleDownloadAppraisalsAndExpensesForSelectedJobsButtonClick(
               e, this.state.data.id
             );
            }}
            disabled={this.state.selectedJobsZipping === true}
          >
          <i className="fa fa-download"></i>&nbsp;
          <i className="fa fa-file-archive"></i>&nbsp;
          Download Appraisals and Expenses for all selected jobs into ZIP
            &nbsp;&nbsp;
            {
              (this.state.selectedJobsZipping === true) ?
                <i className="fas fa-cog fa-spin"></i>
                :
                ''
            }

          </button>

          <button
            className="btn btn-lg btn-success customer-invoicing-sage-csv-button"
            onClick={(e) => {
              e.preventDefault();
              this.handleInvoiceExportButtonClick(e, this.state.data.id)}
            }
          >
            <i className="fa fa-download"></i>&nbsp;
            Export all selected Jobs into one Sage invoice CSV
          </button>

          <button className="btn btn-lg btn-primary customer-invoicing-xero-csv-button" onClick={(e) => {e.preventDefault();this.handleXeroInvoiceExportButtonClick(e, this.state.data.id)}}>
            <i className="fa fa-download"></i>&nbsp;Export all selected Jobs into XERO
          </button>
        </div>

      </div>
    )
  }
}
